import { Text, View } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const InfoContainer = styled(View, theme => {
  return {
    base: {
      flexDirection: 'column',
      gap: theme.spacingStackOnepulse,
    },
  }
})

export const InfoTitle = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightSmall
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      maxWidth: theme.sizingColossal,
    },
  }
})

export const InfoBrand = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralAlternative,
      fontFamily: theme.fontFamily.semiBold,
      fontSize: theme.fontSizeThreepulse,
      maxWidth: theme.sizingColossal,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})

export const InfoDetail = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralAlternative,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreepulse,
      maxWidth: theme.sizingColossal,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})

export const InfoQuantity = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralPlaceholder,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreepulse,
      maxWidth: theme.sizingColossal,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})

export const InfoMarketplaceContainer = styled(View, theme => {
  return {
    base: {
      width: '100%',
      justifyContent: 'space-between',
      flexDirection: 'row',
    },
  }
})

export const InfoMarketplaceText = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralPlaceholder,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreepulse,
      maxWidth: theme.sizingColossal,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightSmall
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      paddingRight: theme.spacingInlineHalfpulse,
    },
  }
})

export const PimTagContainer = styled(View, theme => {
  return {
    base: {
      backgroundColor: theme.colorFillNeutralDefault,
      borderColor: theme.colorBorderNeutralAlternative,
      borderWidth: theme.borderWidthQuarterpulse,
      borderRadius: theme.borderRadiusPill,
      paddingVertical: theme.paddingInsetHalfpulse,
      paddingHorizontal: theme.paddingInsetThreepulse,
      width: 'auto',
      alignSelf: 'flex-start',
    },
  }
})

export const PimTagLabel = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      fontFamily: theme.fontFamily.regular,
    },
  }
})
